import * as angular from 'angular';

/**
 * The purpose of this directive is to address cases where you have scrolling
 * within a child element but you want to prevent the body or parent element from scrolling
 * when the child element has reached its scroll limit
 *
 * USAGE:
 * <element aptitude-stop-scroll-event-bubble />
 *
 * TODO:
 *   add improvement to test if entire element is in view port, in which case
 *   it would be better to allow the parent or body to scroll
 */
export default function AptitudeStopScrollEventBubble() {
  return {
    restrict: 'A',
    link: function ($scope, $element, $attrs) {
      var previousScroll = 0;

      $element.on(
        'DOMMouseScroll mousewheel MozMousePixelScroll wheel',
        function (e) {
          var el = angular.element(e.currentTarget);
          var maxScroll = el.prop('scrollHeight');
          var elOuterHeight = el.outerHeight();
          var curScrollHeight = elOuterHeight + el.scrollTop();

          // console.log(curScrollHeight, maxScroll, elOuterHeight, e);

          if (e.stopImmediatePropagation) {
            e.stopImmediatePropagation();
          }
          if (e.stopPropagation) {
            e.stopPropagation();
          }

          if (e.originalEvent.detail > 0 || e.originalEvent.wheelDelta < 0) {
            //scroll down
            if (curScrollHeight < maxScroll) {
              //console.log('Down');
              return;
            }
          } else {
            //scroll up
            if (curScrollHeight > elOuterHeight) {
              //console.log('Up');
              return;
            }
          }

          //stop scroll event to prevent scroll on parent element (usually body)
          return false;
        }
      );
    }
  };
}
